import React, { useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { tryToDeletePartner } from '../../../../store/brokers/admin/partners/partnersSlice';
import Modal from '../../../../shared/modal';
import Error from '../../../../shared/error';
import Button from '../../../../shared/button';


interface IDeletePartnerModal {
    partnerId?: string;
    openModal: boolean;
    handleCloseModal: () => void;
}

const DeletePartnerModal = ({
    openModal,
    partnerId,
    handleCloseModal
}: IDeletePartnerModal) => {
    const dispatch = useAppDispatch();
    const [generalError, setGeneralError] = useState<string>()
    const [selectedOffers, setSelectedOffers] = useState<boolean>(false)
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false)

    const onCloseModal = () => {
        handleCloseModal();
        setSelectedOffers(false)
        setDeleteLoading(false)
        setGeneralError(undefined)
    }

    const onSubmit = async () => {
        setDeleteLoading(true)
        try {
            await dispatch(tryToDeletePartner(partnerId || '')).unwrap()
            onCloseModal()
            setGeneralError(undefined)
            setDeleteLoading(false)
        }
        catch (err) {
            setGeneralError(`${err || 'Something went wrong, please try again or contact our team'}`)
            setDeleteLoading(false)
        }
    }

    const onSelectOffers = () => {
        setSelectedOffers(!selectedOffers)
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[400px]'}>
                <p className='mb-2 font-semibold text-sm'>Delete Partner</p>
                <p className='mb-6 text-sm'>Are you sure you want to delete Partner?</p>
                {generalError && <Error text={generalError} />}
                <div className='flex flex-col items-center'>
                    <Button
                        label={'Delete Partner'}
                        className={`${deleteLoading ? 'btn-primary-rounded-less-disable !cursor-not-allowed' : 'btn-error'} my-8 min-w-[200px] !rounded !shadow-none`}
                        type='submit'
                        disabled={deleteLoading}
                        onClickButton={onSubmit}
                        dataQa={'delete-partner-btn'}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default DeletePartnerModal;